import { Button, Typography, makeStyles } from '@material-ui/core'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import React from 'react'

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${pxToRem(6)} ${pxToRem(12)}`,
        borderBottom: '1px solid #E0E0E0',
        flexShrink: 0,
    },
    scopeText: {
        fontSize: pxToRem(12),
        fontWeight: 400,
        color: '#424242',
        textTransform: 'uppercase' as const,
    },
    scopeLabel: {
        color: '#737373',
    },
    selectAllButton: {
        fontSize: pxToRem(12),
        padding: 0,
        minWidth: 0,
        textTransform: 'none' as const,
    },
}))

/** Props for {@link SelectionScopeBar}. */
export interface SelectionScopeBarProps {
    /** Number of currently selected items. */
    selectedCount: number
    /** Total number of selectable items. */
    totalCount: number
    /** Label displayed after the counts, e.g. `"sections"`. */
    itemLabel: string
    /** Optional prefix label shown before the count, e.g. `"SCOPE"`. */
    label?: string
    /** Called when the user clicks "Select all". */
    onSelectAll: () => void
    /** Called when the user clicks "Unselect all" (shown when all items are selected). */
    onUnselectAll: () => void
    className?: string
}

const SELECT_ALL_LABEL = 'Select all'
const UNSELECT_ALL_LABEL = 'Unselect all'

/** Displays a selection count summary with a "Select all" / "Unselect all" toggle action. */
const SelectionScopeBar = ({
    selectedCount,
    totalCount,
    itemLabel,
    label,
    onSelectAll,
    onUnselectAll,
    className = '',
}: SelectionScopeBarProps) => {
    const classes = useStyles()
    const allSelected = totalCount > 0 && selectedCount === totalCount

    return (
        <div className={`${classes.root} ${className}`}>
            <Typography component="span" className={classes.scopeText}>
                {label && <span className={classes.scopeLabel}>{label}&nbsp;&nbsp;</span>}
                {selectedCount} of {totalCount} {itemLabel}
            </Typography>
            <Button
                variant="text"
                className={classes.selectAllButton}
                onClick={allSelected ? onUnselectAll : onSelectAll}
            >
                {allSelected ? UNSELECT_ALL_LABEL : SELECT_ALL_LABEL}
            </Button>
        </div>
    )
}

export default SelectionScopeBar
